/**
 * Format given number by thousand separator
 * @param {*} number
 */
function format(number) {
  try {
    if (number) {
      let num_parts = number.toString().split(".");
      num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return num_parts.join(".");
    }
    // eslint-disable-next-line no-empty
  } catch (error) { }

  return number;
}

module.exports = {
  format
};
